// Role of the referred patient within the referring organization's insurance
// plan (PPL-3490). Values are stable slug keys stored in referrals and
// forwarded to the patient platform via the booking link.
export enum CoverageRole {
  principal = 'principal',
  dependant = 'dependant',
}

export function displayCoverageRole(value: CoverageRole) {
  switch (value) {
    case CoverageRole.principal:
      return 'Principal';
    case CoverageRole.dependant:
      return 'Dependant';
    default:
      throw new Error(`Unknown coverage role: ${value}`);
  }
}
